import RestApiClient from '../../../core/api/RestApiClient';
import { User } from '../types/User';

export default {
  getUsers: async (moduleId: number): Promise<User[]> => {
    return await RestApiClient.get<User[]>(`modules/UsersStatisticsModule/${moduleId}`);
  },
};
